import {statePrograms, StateProgramsState} from './statePrograms';
import {combineReducers} from 'redux';
import {stateAssignments, StateAssignmentsState} from './stateAssignments';
import {expenseLiabilities, ExpenseLiabilityState} from './expenseLiabilities';

export interface SocialSupportState {
  statePrograms: StateProgramsState;
  stateAssignments: StateAssignmentsState;
  expenseLiabilities: ExpenseLiabilityState;
}

export const socialSupport = combineReducers({
  statePrograms,
  stateAssignments,
  expenseLiabilities,
});
